// Port of webapp/src/components/sidebar/sidebarBoardItem.tsx

import {ReactElement} from 'react'
import classnames from 'classnames'
import {useNavigate} from 'react-router-dom'
import {Board} from '../../types/board'
import {BoardView} from '../../types/boardView'
import {buildBoardPath} from '../../common/paths'
import * as mutator from '../../state/mutator'
import {Icon} from '../common/icons'
import {ButtonWithMenu, Menu, MenuItem, MenuSeparator} from '../common/menu'

type Props = {
    board: Board
    views: BoardView[]
    activeBoardId: string
    activeViewId: string | undefined
    teamId: string
    readOnly: boolean
}

export default function SidebarBoardItem({board, views, activeBoardId, activeViewId, teamId, readOnly}: Props): ReactElement {
    const navigate = useNavigate()
    const isActive = board.id === activeBoardId

    return (
        <div
            className={classnames(
                'SidebarBoardItem octo-sidebar-item flex h-[30px] items-center gap-2 rounded-none pl-7 pr-2',
                isActive ? 'bg-white/10 text-sidebar-fg' : 'text-sidebar-fg/70 hover:bg-white/10 hover:text-sidebar-fg',
            )}
        >
            <button
                type='button'
                onClick={() => navigate(buildBoardPath({teamId, boardId: board.id, viewId: activeViewId && views.some((v) => v.id === activeViewId) ? activeViewId : views[0]?.id}))}
                className='flex min-w-0 flex-1 items-center gap-2 text-left'
                aria-current={isActive ? 'true' : undefined}
            >
                <span className='octo-sidebar-icon shrink-0' aria-hidden={true}>{board.icon || '📋'}</span>
                <span className='octo-sidebar-title truncate' title={board.title}>{board.title || '未命名'}</span>
            </button>

            {!readOnly && (
                <ButtonWithMenu
                    button={
                        <span className='IconButton h-5 w-5 shrink-0' aria-label={`「${board.title}」的选项`}>
                            <Icon name='dots' size={13}/>
                        </span>
                    }
                >
                    <Menu ariaLabel='看板选项'>
                        <MenuItem
                            icon='edit'
                            onClick={() => {
                                const title = window.prompt('看板名称', board.title)
                                if (title !== null && title !== board.title) {
                                    void mutator.changeBoardTitle(board.id, title)
                                }
                            }}
                        >
                            重命名看板
                        </MenuItem>
                        <MenuSeparator/>
                        <MenuItem
                            icon='trash'
                            danger={true}
                            onClick={() => {
                                if (window.confirm(`确定删除看板「${board.title}」？`)) {
                                    void mutator.deleteBoard(board.id)
                                }
                            }}
                        >
                            删除看板
                        </MenuItem>
                    </Menu>
                </ButtonWithMenu>
            )}
        </div>
    )
}
